import { httpModifierAdapter } from './Modifiers.http';

export default httpModifierAdapter;
